import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetTkv2OrdersAPIError,
  GetTkv2OrdersAPIVariables,
  fetchGetTkv2OrdersAPI,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getTkv2OrdersAPI;

export function useGetTkv2OrdersAPI(
  variables: GetTkv2OrdersAPIVariables,
  opts?: UseQueryOptions<Response, GetTkv2OrdersAPIError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetTkv2OrdersAPIError>(
    queryKeyFn({
      path: '/api/v2/orders',
      operationId: 'getTkv2OrdersAPI',
      variables,
    }),
    async () => {
      const res = await fetchGetTkv2OrdersAPI({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
